import { connect } from 'react-redux'
import { compose, mapProps, withHandlers, withProps } from 'recompose'
import { googleAnalyticProductClicks } from 'actions/googleAnalytic'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { formatPhoneNumber } from 'helpers/phone-number'
import { commaCheckAndFormatPrice, getGTMTireLineData } from '../../helpers'
import TireLineTile from './TireLineTile'
import { getReviewsLink } from 'helpers/location'
import { SEARCH_RESULT_SOURCE } from 'constant'


const mapStateToProps = state => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state),
  formattedStorePhoneNumber: formatPhoneNumber(getCurrentStorePhoneNumber(state))
})

const withSetReviewLink = mapProps(({ productLink, ...props }) => ({
  ...props,
  productLink,
  reviewsLink: getReviewsLink(productLink)
}))

const withPriceInformation = withProps(({ startingListPrice, hasStore, hasMapPrice }) => ({
  isShowSelectStore: !hasStore,
  isShowPrice: hasStore && !!Number(commaCheckAndFormatPrice(startingListPrice)) && !hasMapPrice,
  isShowCallStoreForPrice: hasStore && !Number(commaCheckAndFormatPrice(startingListPrice)) && !hasMapPrice,
  isSeePriceIncart: hasStore && hasMapPrice
}))

const withTireLineClickHandler = withHandlers({
  handleTireLineClick: ({
    season,
    tireType,
    brandName,
    index: position,
    productDisplayName,
    startingListPrice,
    'product.repositoryId': id,
    googleAnalyticProductClicks
  }) => () => {
    googleAnalyticProductClicks({
      data: getGTMTireLineData({
        brandName,
        tireLine: {
          season,
          tireType,
          position,
          brandName,
          startingListPrice,
          productDisplayName,
          'product.repositoryId': id
        }
      }),
      ...SEARCH_RESULT_SOURCE
    })
  }
})


export default compose(
  connect(mapStateToProps, { googleAnalyticProductClicks }),
  withTireLineClickHandler,
  withSetReviewLink,
  withPriceInformation
)(TireLineTile)
